import React, { SVGAttributes } from 'react';

/**
 * Info icon with outlined/stroked circle design.
 * Used in cart discount banners and similar UI elements.
 */
export function InfoCircleOutline(props: SVGAttributes<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      role='img'
      {...props}
    >
      <title>Information</title>
      <circle cx='8' cy='8' r='7' stroke='currentColor' strokeWidth='1.5' fill='none' />
      <path d='M8 7V11' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
      <circle cx='8' cy='5' r='0.75' fill='currentColor' />
    </svg>
  );
}
